<template>
  <div>
    <v-container v-if="!headers">
      <v-row justify="center">
        <v-progress-circular
          :size="70"
          :width="7"
          color="accent"
          indeterminate
        ></v-progress-circular>
      </v-row>
    </v-container>
    <div v-else>
      <v-card>
        <v-card-text>
          <v-row>
            <v-col
              cols="6"
              v-if="
                headers.some(
                  (h) => h.text === 'headers.members_management.First Name'
                )
              "
            >
              <no-autocomplete-textfield
                clearable
                v-model="searchForm.firstName"
                :label="$t('headers.members_management.First Name')"
              />
            </v-col>
            <v-col
              cols="6"
              v-if="
                headers.some(
                  (h) => h.text === 'headers.members_management.Last Name'
                )
              "
            >
              <no-autocomplete-textfield
                clearable
                v-model="searchForm.lastName"
                :label="$t('headers.members_management.Last Name')"
              />
            </v-col>
            <v-col
              cols="6"
              v-if="
                headers.some(
                  (h) => h.text === 'headers.members_management.Certificate'
                )
              "
            >
              <no-autocomplete-textfield
                clearable
                v-model="searchForm.certificate"
                :label="$t('headers.members_management.Certificate')"
              />
            </v-col>
            <v-col
              cols="6"
              v-if="
                headers.some((h) => h.text === 'headers.members_management.SIN')
              "
            >
              <no-autocomplete-textfield
                clearable
                v-model="searchForm.sin"
                :label="$t('headers.members_management.SIN')"
              />
            </v-col>
            <v-col
              cols="6"
              v-if="
                headers.some(
                  (h) => h.text === 'headers.members_management.Employee Number'
                )
              "
            >
              <no-autocomplete-textfield
                clearable
                v-model="searchForm.employeeNumber"
                :label="$t('headers.members_management.Employee Number')"
              />
            </v-col>
            <v-col
              cols="6"
              v-if="
                headers.some(
                  (h) => h.text === 'headers.members_management.Gender'
                )
              "
            >
              <trans-select
                :clearable="true"
                :item="searchForm"
                propertyName="gender"
                :items="options.Models.Gender"
                :label="$t('headers.members_management.Gender')"
              ></trans-select>
            </v-col>
            <v-col
              cols="6"
              v-if="
                headers.some(
                  (h) => h.text === 'headers.members_management.Date Of Birth'
                )
              "
            >
              <pbas-date-picker
                :clearable="true"
                :label="$t('headers.members_management.Date Of Birth')"
                :value="searchForm.dateOfBirth"
                @update-date="searchForm.dateOfBirth = $event"
              ></pbas-date-picker>
            </v-col>
            <v-col cols="6">
              <auto-select
                v-model="searchForm.operator"
                :label="$t('components.searchmemberformhours.operator')"
                :items="operators"
              />
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="auto">
              <v-btn color="primary" @click="submitSearchForm">
                {{ $t("pbascomponents.pbasdatatable.search") }}
              </v-btn>
            </v-col>
            <v-col cols="auto">
              <v-btn
                text
                @click="
                  searchForm.firstName = '';
                  searchForm.lastName = '';
                  searchForm.certificate = '';
                  searchForm.sin = '';
                  searchForm.employeeNumber = '';
                  searchForm.gender = '';
                  searchForm.dateOfBirth = '';
                  submitSearchForm();
                "
              >
                {{ $t("globals.reset") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <v-card style="margin-top:20px">
        <v-card-text>
          <div>
            <v-icon>list</v-icon>
            {{ $t("components.membersmanagementtable.results") }}
          </div>
          <pbas-data-table
            v-if="usedInMerge"
            ref="table"
            :dataProvider="provider"
            fileNamePrefix="members"
            identifier="search-member-table"
            :noSearch="true"
            :noActions="true"
            @error="error = $event"
            :rowActions="inMergeRowActions"
          ></pbas-data-table>
          <pbas-data-table
            v-else
            ref="table"
            :dataProvider="provider"
            :rowActions="rowActions"
            fileNamePrefix="members"
            identifier="search-member-table"
            :noSearch="true"
            :noActions="true"
            @error="error = $event"
          ></pbas-data-table>
        </v-card-text>
      </v-card>
    </div>
    
    <error-handler :error="error"></error-handler>
    <v-dialog
      v-model="dialogs.mergeWarning"
      max-width="600px"
      persistent
      scrollable
    >
      <material-card
        :title="$t('components.hoursbulktable.merge_warning_title')"
        :color="$vuetify.theme.themes.light.warning"
        icon="merge_type"
      >
        <v-card-text>
          {{ $t("components.hoursbulktable.merge_warning_text") }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.mergeWarning = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="primary" @click="merge">
            {{ $t("components.hoursbulktable.merge") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import { ODataHeader, ODataString } from "pbas-vue-components";
import { translate2 } from "../trans2";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import { planSetter } from "../mixins/planSetter";
import AutoSelect from "./AutoSelect.vue";
import TransSelect from "../components/TransSelect";
import { translate } from "../trans";

export default {
  name: "search-members-form",
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    AutoSelect,
    TransSelect,
  },
  props: [
    "firstName",
    "lastName",
    "certificate",
    "employeeNumber",
    "gender",
    "dateOfBirth",
    "sin",
    "usedInMerge",
  ],
  mixins: [planSetter],
  data() {
    return {
      showTable: false,
      panel: [0, 1],
      searchForm: {
        firstName: null,
        lastName: null,
        certificate: null,
        sin: null,
        email: null,
      },
      error: null,
      provider: undefined,
      rowActions: [
        {
          name: "viewItem",
          icon: "visibility",
          title: "components.membersmanagementtable.details",
          handler: (item) => {
            this.$router.push({ name: "memberView", params: { id: item.Id } });
          },
          visible: (item) => {
            return item;
            // return !this.usedInMerge;
          },
        },
      ],
      inMergeRowActions: [
        {
          name: "merge",
          icon: "visibility",
          title: "components.hoursbulktable.merge",
          handler: (item) => {
            this.item = item;
            this.dialogs.mergeWarning = true;
          },
        },
      ],
      headers: undefined,
      selectedItem: null,
      dialogs: {
        mergeWarning: false,
      },
      item: null,
      operators: ["And", "Or"],
    };
  },
  computed: {
    ...mapGetters("common", { selectedPlan: "plan" }),
    ...mapGetters("common", ["language"]),
    ...mapGetters("plansMembers", ["options"]),
  },
  watch: {
    firstName: {
      handler(v) {
        this.searchForm.firstName = v;
        this.submitSearchForm();
      },
    },
    lastName: {
      handler(v) {
        this.searchForm.lastName = v;
        this.submitSearchForm();
      },
    },
    certificate: {
      handler(v) {
        this.searchForm.certificate = v;
        this.submitSearchForm();
      },
    },
  },
  async mounted() {
    await this.loadPlanData();
    console.log(
      "***********************",
      this.firstName,
      this.lastName,
      this.certificate,
      this.employeeNumber,
      this.gender,
      this.dateOfBirth,
      this.sin
    );
    if (
      this.firstName ||
      this.lastName ||
      this.certificate ||
      this.employeeNumber ||
      this.gender ||
      this.dateOfBirth ||
      this.sin
    ) {
      this.searchForm.firstName = this.firstName;
      this.searchForm.lastName = this.lastName;
      this.searchForm.certificate = this.certificate;
      this.searchForm.employeeNumber = this.employeeNumber;
      this.searchForm.dateOfBirth = this.dateOfBirth;
      this.searchForm.sin = this.sin;
      if (this.gender) {
        const genders = this.options.Models.Gender.filter(
          (o) => translate(o, this.language.language) === this.gender
        );
        if (genders.length > 0) {
          this.searchForm.gender = genders[0];
        }
      }
      this.searchForm.operator = this.operators[0];
      this.submitSearchForm();
    }
  },
  methods: {
    ...mapActions("plansMembers", ["getMembersManagementColumns"]),
    ...mapActions("common", ["createOdataType"]),
    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },
    merge() {
      console.log(this.item);
      this.$emit("merge", this.item);
      this.dialogs.mergeWarning = false;
    },
    async loadPlanData(filter = null) {
      try {
        let headers = (await this.getMembersManagementColumns(
          this.selectedPlan.Id
        )).data.sort((a, b) => {
          return a.order - b.order;
        });

        this.headers = this.$helpers.createOdataHeaders(
          headers.filter((h) => h.showOnExpand === true), "headers.members_management."
        );
        let coverageHeader = this.headers.filter(
          (o) =>
            o.title ===
            "headers.members_management.CoverageIdentitiesTranslations"
        )[0];
        let coverageHeaderIndex = this.headers.indexOf(coverageHeader);
        this.headers[coverageHeaderIndex] = new ODataHeader({
          title: "headers.members_management.CoverageIdentitiesTranslations",
          type: new ODataString(
            "CoverageIdentities[]/History[]/Translations[]/Name",
            {
              getString: (item) => {
                return item.CoverageIdentities.map((o) => o.History)
                  .map(
                    (o) =>
                      o
                        .filter(
                          (oo) =>
                            Date.parse(oo.EffectiveDate) <=
                            Date.parse(item.EffectiveDate)
                        )
                        .sort(
                          (a, b) =>
                            Date.parse(a.EffectiveDate) >
                            Date.parse(b.EffectiveDate)
                        )[0]
                  )
                  .map((o) => translate2(o, "Name"))
                  .join(", ");
              },
              getHtml: (item, type) => {
                return (
                  "<div style='word-wrap: break-word; white-space: pre-wrap; min-width: 200px'>" +
                  type.getString(item, type) +
                  "</div>"
                );
              },
            }
          ),
          sortable: true,
          visible: true,
          searchable: true,
          version: 20,
        });
        const h2 = this.$helpers.createOdataHeaders(
          // headers.filter(
          //   (h) =>
          //     h.text === "First Name" ||
          //     h.text === "Last Name" ||
          //     h.text === "SIN" ||
          //     h.text === "Certificate" ||
          //     h.text === "Email" ||
          //     h.text === "Gender" ||
          //     h.text === "Date Of Birth" ||
          //     h.text === "Employer" ||
          //     h.text === "Employee Number" ||
          //     h.text === "Store" ||
          //     h.text === "Employment Frequency" ||
          //     h.text === "Employment Type" ||
          //     h.text === "Hire Date" ||
          //     h.text === "Start Date" ||
          //     h.text === "End Date" ||
          //     h.isId === true
          // )
          headers.filter((h) => h.showOnExpandOnly !== true), "headers.members_management."
        );
        this.headers = h2;
        let url = "plans/" + this.selectedPlan.Id + "/find-members";
        if (!filter) {
          this.provider = new PbasOData(this.$axiosHttp, url, h2);
        } else {
          const pr = new PbasOData(this.$axiosHttp, url, h2);
          pr.filter = filter;
          this.provider = pr;
        }
      } catch (error) {
        this.error = error;
      }
    },
    async submitSearchForm() {
      const filters = [];
      this.provider.filter = undefined;
      if (this.searchForm.firstName) {
        filters.push(
          `contains(tolower(CurrentMember/FirstName), '${this.searchForm.firstName
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
      }
      if (this.searchForm.lastName) {
        filters.push(
          `contains(tolower(CurrentMember/LastName), '${this.searchForm.lastName
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
      }
      if (this.searchForm.certificate) {
        filters.push(
          `contains(tolower(MemberIdentification/Certificate), '${this.searchForm.certificate
            .toLowerCase()
            .replaceAll("'", "''")}')`
        );
        // filters.push(
        //   `startswith(MemberIdentification/Certificate, '${this.searchForm.certificate.replaceAll(
        //     "'",
        //     "''"
        //   )}')`
        // );
      }
      if (this.searchForm.sin) {
        filters.push(
          `(contains(tolower(MemberIdentification/SIN), '${this.searchForm.sin
            .toLowerCase()
            .replaceAll("'", "''")}') or
          contains(tolower(MemberIdentification/TemporarySIN), '${this.searchForm.sin
            .toLowerCase()
            .replaceAll("'", "''")}'))`
        );
      }
      if (this.searchForm.employeeNumber) {
        filters.push(
          `contains(tolower(CurrentEmploymentInformation/EmployeeNumber), '${this.searchForm.employeeNumber.toLowerCase()}')`
        );
      }

      if (this.searchForm.dateOfBirth) {
        filters.push(
          `(date(CurrentMember/DateOfBirth) eq ${
            this.searchForm.dateOfBirth.split("T")[0]
          })`
        );
      }

      if (this.searchForm.gender) {
        filters.push(
          `(CurrentMember/Gender/Translations/any(C_G_t: contains(tolower(C_G_t/DisplayValue), '${translate(
            this.searchForm.gender,
            this.language.language
          ).toLowerCase()}')))`
        );
      }

      if (filters.length > 0) {
        let f = filters.join(` ${this.searchForm.operator.toLowerCase()} `);
        console.log(filters, f);
        this.provider.filter = f;
        this.showTable = true;
        this.$nextTick(() => {
          this.$refs.table.getDataAsync();
        });
      } else {
        this.showTable = false;
      }

      //await this.loadPlanData(filters.join(" and "));
    },
  },
};
</script>
